/* eslint-disable no-unused-vars */
export enum AccentedBackgrounds {
  CLIPPED = 'clipped',
  DOUBLE_CLIPPED = 'double-clipped',
  CLIPPED_RESPONSIVE = 'clipped-responsive',
  DOUBLE_CLIPPED_RESPONSIVE = 'double-clipped-responsive',
  NONE = '',
}
